import { Injectable, signal, TemplateRef } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root',
})
export class DrawerService {
  drawer?: MatDrawer;
  title = signal('');
  content = signal<TemplateRef<any> | null>(null);
  subTitle = signal('');

  width = signal('65vw');

  constructor() {}

  open(config: DrawerConfig) {
    this.title.set(config.title);
    this.content.set(config.template);
    this.width.set(config.width ?? '65vw');
    this.drawer!.open();
  }

  close() {
    this.drawer?.close();
  }
}

interface DrawerConfig {
  title: string;
  template: TemplateRef<any>;
  width?: string;
  subTitle?: string;
}
